<style scoped>
    .expand-row{
        margin-bottom: 16px;
    }
</style>
<template>
    <div>
         <Table :columns="columnsExpand" :data="row.items" stripe ref="table" ></Table>
    </div>
</template>
<script>
    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    export default {
        props: {
            row: Object
        },
         data() {
            var columns =  [
                    {
                        title: Util.L('Qty'),
                        key: 'qty',
                        align: "right",
                        width:120,
                         render: (h, params) => {
                            return h("span", Util.toViewNumberString(Math.abs(params.row.qty)));
                        }
                    },
                    {
                        title: Util.L('SKU'),
                        key: 'sku',
                        width:150
                    },
                    {
                        title: Util.L('ProductName'),
                        key: 'productName'
                    },
                    {
                        title: Util.L('Unit'),
                        key: 'unitName',
                         width:120
                    }
                ]

            return {
                columnsExpand : columns,
            }
        },
    };
</script>
